<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-md-12">
        <div>
          <h1 class="title-default">
            Edição de Parcela
            @if (nroParcela && qtdParcelas) {
              <span class="parcela-badge">{{ nroParcela }}/{{ qtdParcelas }}</span>
            }
          </h1>
          <p class="welcome-message">
            <button mat-icon-button [routerLink]="rotaVoltar">
              <mat-icon>arrow_back</mat-icon>
            </button>
            Parcela de:
            @if (descricaoOriginal) {
              {{ descricaoOriginal }}
              @if (nomeFornecedor) {
                — {{ nomeFornecedor }}
              }
              <a
                mat-button
                [routerLink]="[
                  '/financas/contas-pagar/cadastrar',
                  { idContasPagar: idContasPagar, idContasPagarParcela: idContasPagarParcela },
                ]">
                Ver Conta a Pagar
              </a>
            } @else {
              Edição de parcela de conta a pagar
            }
          </p>
        </div>
      </div>
    </div>

    @if (isLoading || isLoadingLookups) {
      <div class="row">
        <div class="col-12 mb-4">
          <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>
          <div class="row">
            <div class="col-12 mb-3">
              <app-loading-box [height]="'150'"></app-loading-box>
            </div>
            <div class="col-6 mb-3">
              <app-loading-box [height]="'100'"></app-loading-box>
            </div>
            <div class="col-6 mb-3">
              <app-loading-box [height]="'100'"></app-loading-box>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <form [formGroup]="form" (ngSubmit)="salvar()">
        <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

        @if (isContaCartao) {
          <app-alert-card type="info" icon="credit_card" class="mb-3 d-block">
            Conta tipo <strong>Cartão de Crédito</strong> — fecha dia <strong>{{ diaFechamentoCartao }}</strong>,
            vence dia <strong>{{ diaVencimentoCartao }}</strong>. O vencimento será ajustado automaticamente para o ciclo da fatura.
          </app-alert-card>
        }

        <!-- ─── Dados da Parcela ─── -->
        <div class="section-container" id="dados-parcela">
          <div class="section-title">
            <mat-icon>receipt_long</mat-icon>
            <span>Dados da Parcela</span>
          </div>
          <div class="row pt-2 pb-1">
            <div class="col-12 col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor (R$)</mat-label>
                <input matInput formControlName="valor" [currencyMask]="currencyMask" />
              </mat-form-field>
            </div>

            <div class="col-12 col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Vencimento</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerVenc"
                  [matDatepickerFilter]="cartaoDateFilter"
                  [readonly]="isContaCartao"
                  formControlName="dataVencimento"
                  (input)="onDateInput($event, 'dataVencimento')" />
                <mat-datepicker-toggle matIconSuffix [for]="pickerVenc"></mat-datepicker-toggle>
                <mat-datepicker #pickerVenc [startView]="isContaCartao ? 'year' : 'month'"
                  (monthSelected)="onMonthSelected($event, pickerVenc, form.get('dataVencimento'))">
                </mat-datepicker>
                @if (!podeEditarVencimento) {
                  <mat-hint class="text-warning">Bloqueado: há pagamento parcial</mat-hint>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="descricao" />
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              @if (listaFormaPagamento.length > 0) {
                <app-select-pesquisavel
                  [control]="idFormaPagamentoControl"
                  [offlineList]="listaFormaPagamento"
                  label="Forma de Pagamento"
                  idField="idFormaPagamento"
                  nameField="descricao"
                  [isOptional]="true">
                </app-select-pesquisavel>
              }
            </div>

            <div class="col-12 col-md-4">
              @if (listaContaFinanceira.length > 0) {
                <app-select-pesquisavel
                  [control]="idContaFinanceiraControl"
                  [offlineList]="listaContaFinanceira"
                  label="Conta Financeira"
                  idField="idContaFinanceira"
                  nameField="descricao"
                  [isOptional]="true">
                </app-select-pesquisavel>
              }
            </div>
          </div>
        </div>

        <!-- ─── Centro de Custo / Rateio (pertence ao documento pai) ─── -->
        <div class="section-container" id="centro-custo">
          <div class="section-title">
            <mat-icon>pie_chart</mat-icon>
            <span>Centro de Custo</span>
          </div>
          <div class="pt-2 pb-1">
            <app-contas-pagar-centro-custo
              [parentForm]="form"
              [valorTotalDoc]="valorTotalDocumento"
              [listaCentrosCusto]="listaCentrosCusto"
              [listaGridConfiguracoes]="listaGridConfiguracoesRateio"
              [currencyMask]="currencyMask"
              [percentageMask]="percentageMask">
            </app-contas-pagar-centro-custo>
          </div>
        </div>

        <!-- ─── Previsão de Pagamento ─── -->
        <div class="section-container" id="previsao">
          <div class="section-title">
            <mat-icon>monetization_on</mat-icon>
            <span>Previsão de Pagamento</span>
          </div>
          <div class="row pt-2 pb-1">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Previsão para Pagamento</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerPrev"
                  formControlName="datetimePrevisao"
                  (input)="onDateInput($event, 'datetimePrevisao')" />
                <mat-datepicker-toggle matIconSuffix [for]="pickerPrev"></mat-datepicker-toggle>
                <mat-datepicker #pickerPrev></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-2 text-danger">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Juros Previsto</mat-label>
                <input matInput formControlName="valorJurosPrevisto" [currencyMask]="currencyMask" />
                <mat-icon matSuffix class="text-danger">trending_up</mat-icon>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-2 text-danger">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Multa Prevista</mat-label>
                <input matInput formControlName="valorMultaPrevisto" [currencyMask]="currencyMask" />
                <mat-icon matSuffix class="text-danger">gavel</mat-icon>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-2 text-danger">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Acréscimo Previsto</mat-label>
                <input matInput formControlName="valorAcrescimoPrevisto" [currencyMask]="currencyMask" />
                <mat-icon matSuffix class="text-danger">add_circle_outline</mat-icon>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-2 text-success">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Desconto Previsto</mat-label>
                <input matInput formControlName="valorDescontoPrevisto" [currencyMask]="currencyMask" />
                <mat-icon matSuffix class="text-success">trending_down</mat-icon>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- ─── Resumo da Baixa (Liquidações) ─── -->
        @if (liquidacoes.length > 0) {
          <div class="section-container" id="resumo-baixa">
            <div class="section-title">
              <mat-icon>account_balance_wallet</mat-icon>
              <span>Resumo da Baixa</span>
            </div>
            <div class="table-responsive mt-2">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th class="text-end">Valor Principal</th>
                    <th class="text-end">Juros</th>
                    <th class="text-end">Multa</th>
                    <th class="text-end">Desconto</th>
                    <th class="text-end">Total Liquidado</th>
                  </tr>
                </thead>
                <tbody>
                  @for (liq of liquidacoes; track $index) {
                    <tr>
                      <td>{{ liq.datetimeLiquidacao | date: 'dd/MM/yyyy' }}</td>
                      <td class="text-end">{{ liq.valorPrincipalLiquidado | abnt: 'preco' }}</td>
                      <td class="text-end">{{ liq.valorJurosLiquidado | abnt: 'preco' }}</td>
                      <td class="text-end">{{ liq.valorMultaLiquidado | abnt: 'preco' }}</td>
                      <td class="text-end">{{ liq.valorDescontoLiquidado | abnt: 'preco' }}</td>
                      <td class="text-end fw-bold">{{ liq.valorTotalLiquidado | abnt: 'preco' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        <!-- ─── Complementos ─── -->
        <div class="section-container" id="complementos">
          <div class="section-title">
            <mat-icon>description</mat-icon>
            <span>Complementos</span>
          </div>
          <div class="row pt-2 pb-1">
            <div class="col-12 mb-3">
              <app-select-pesquisavel
                label="Tags"
                [offlineList]="listaTags"
                [control]="tagsControl"
                idField="idTagContasPagar"
                nameField="descricao"
                corField="cor"
                [multiple]="true"
                [showBadges]="true"
                placeholder="Selecione...">
              </app-select-pesquisavel>
            </div>

            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100 mb-2">
                <mat-label>Observações</mat-label>
                <textarea
                  matInput
                  formControlName="observacoesHtml"
                  rows="3"
                  placeholder="Insira quaisquer anotações relevantes"></textarea>
              </mat-form-field>
            </div>

            @if (mostrarCodigoBarras) {
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Código de Barras ou Linha Digitável</mat-label>
                <input matInput formControlName="codigoBarrasLinhaDigitavel" placeholder="Insira..." />
              </mat-form-field>
            </div>
            }

            @if (mostrarChavePix) {
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Chave PIX ou Endereço PIX</mat-label>
                <input matInput formControlName="chavePix" placeholder="Insira..." />
              </mat-form-field>
            </div>
            }

            <!-- Drag zone -->
            <div class="col-12">
              <div
                class="upload-container"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">
                <input
                  type="file"
                  #fileInput
                  multiple
                  (change)="onFileSelected($event)"
                  style="display: none" />
                <div class="upload-dropzone" (click)="fileInput.click()">
                  <mat-icon class="upload-icon">cloud_upload</mat-icon>
                  <p class="upload-text"><strong>Clique para enviar</strong> ou arraste e solte</p>
                  <p class="upload-hint">Limitado a 2mb por arquivo (Máximo 10MB Total)</p>
                </div>
              </div>
            </div>

            <!-- Lista de Arquivos -->
            <div class="col-12">
              @if (anexos.length > 0) {
                <div class="file-list mt-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <p class="mb-0 font-weight-bold">Arquivos Selecionados:</p>
                    <button type="button" mat-button (click)="limparAnexos()">
                      <mat-icon>delete_sweep</mat-icon> Limpar Todos
                    </button>
                  </div>
                  @for (file of anexos; track file; let i = $index) {
                    <div class="file-item">
                      <div class="file-info">
                        <mat-icon class="file-icon">description</mat-icon>
                        <div class="file-details">
                          <span class="file-name">{{ file.nomeArquivo }}</span>
                          <span class="file-size">{{ formatBytes(file.tamanhoBytes) }}</span>
                        </div>
                      </div>
                      <div>
                        @if (file.urlArquivo) {
                          <button
                            mat-icon-button
                            type="button"
                            (click)="downloadAnexo(i)"
                            matTooltip="Download arquivo"
                            class="close-icon">
                            <mat-icon>download</mat-icon>
                          </button>
                        }
                        <button
                          mat-icon-button
                          type="button"
                          (click)="removeAnexo(i)"
                          matTooltip="Remover arquivo"
                          class="close-icon">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  (cancelar)="cancelar()"
  (salvar)="salvar()"></app-footer-action>
